export default "__VITE_ASSET__eaa4e3f5__"